import type { Nullable } from "shared/types";

type RandomImplementation = () => number;

let randomImplementation: Nullable<RandomImplementation> = null;

export function setRandom(
  implementation: Nullable<RandomImplementation>
): Nullable<RandomImplementation> {
  const previousImplementation = randomImplementation;

  randomImplementation = implementation;

  return previousImplementation;
}

export default function random(): number {
  return (randomImplementation || Math.random)();
}
